import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {getJournal, getTranslations, journalAsyncActions} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import JournalImg from 'assets/image/menu-auth/jun_journal.png';

import './styles.scss';
import {Link, useParams} from 'react-router-dom';

export const JournalChat: React.FunctionComponent = () => {
  const {
    status: {loading},
    journal: {
      journal
    }
  } = useSelector((state: IStore) => state);
  const dispatch = useDispatch();
  const {journalId} = useParams();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (journalId) {
      dispatch(journalAsyncActions[getJournal](Number(journalId)));
    }
  }, [journalId]);

  useGetTranslations({
    translationKey: TranslationKeys.Chat
  });

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/journals">
        <FormattedMessage
          id={'gritx.journals.breadcrumb.previous'}
          defaultMessage="Journals"
        />
      </Link> {journal && <span className="journal__title-dialogue-name"> - {journal.dialogName}</span>}
    </div>;
  }

  return <div className="journal">
    {
      !loading.includes(getTranslations) && journal && <>
        <h1 className="journal__title">
          <img src={JournalImg} alt="" className="journal__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat mode={BotType.Xpedition} dialogueId={journal.dialogId} title={journal.dialogName} />
      </>
    }
  </div>;
};
